// import React from 'react';
// import { Link } from 'react-router-dom'
// import blog from '../../api/blog';
// import { useParams } from 'react-router-dom'
// import './style.css'
// // Import gallery images
// import maakResidence1 from '../../images/projects/maak-residence-1.jpg';
// import maakResidence2 from '../../images/projects/maak-residence-2.jpg';
// import aizelInterior1 from '../../images/projects/aizel-interior-1.jpg';
// import aizelInterior2 from '../../images/projects/aizel-interior-2.jpg';
// import nos01 from '../../images/projects/4-Nos-01.jpg';
// import img7 from '../../images/projects/7.png';
// import whatsappImg from '../../images/projects/aizel-tower-warsan-1.jpg';

// const BlogSingle = (props) => {

//     const { id } = useParams()

//     const BlogDetails = blog.find(item => item.id === id)

//     // const submitHandler = (e) => {
//     //     e.preventDefault()
//     // }

//     return (
//         <section className="wpo-blog-single-section section-padding">
//             <div className="container">
//                 <div className="row justify-content-center">
//                     <div className="col col-lg-10 col-12">
//                         <div className="wpo-blog-content">
//                             <div className="post format-standard-image">
//                                 <div className="entry-media">
//                                     <img src={aizelInterior2} alt="" />
//                                 </div>
//                                 <div className="entry-meta">
//                                     <ul>
//                                         <li><i className="fi flaticon-user"></i> By <Link to="/blog-single/1">{BlogDetails.author}</Link> </li>
//                                         {/* <li><i className="fi flaticon-comment-white-oval-bubble"></i> Comments {BlogDetails.comment}</li> */}
//                                         <li><i className="fi flaticon-calendar"></i> {BlogDetails.create_at}</li>
//                                     </ul>
//                                 </div>
//                                 <h2>{BlogDetails.title}</h2>
//                                 <p>Architectural design is the art and science of creating functional and aesthetically pleasing spaces that enhance human experience. Great architecture balances form and function, considering factors like sustainability, cultural context, and user needs. Modern architectural practices emphasize energy efficiency, innovative materials, and environmental responsibility while creating structures that inspire and elevate the human spirit. Our approach combines cutting-edge technology with timeless design principles to create spaces that are both beautiful and practical.</p>
//                                 <blockquote>
//                                     Architecture is not just about building structures; it's about creating experiences that transform how people live, work, and interact with their environment. Every design decision should enhance both functionality and beauty.
//                                 </blockquote>
//                                 <p>Our design philosophy centers on understanding the unique requirements of each project and client. We begin with thorough research and analysis of the site, environmental conditions, and user needs. This foundation allows us to develop innovative solutions that respond to specific challenges while creating spaces that inspire. Whether designing residential homes, commercial spaces, or public buildings, we prioritize sustainability, accessibility, and creating meaningful connections between people and their surroundings.</p>

//                                 <div className="gallery">
//                                     <div>
//                                         {id === '1' && <img src={maakResidence1} alt="" />}
//                                         {id === '2' && <img src={aizelInterior1} alt="" />}
//                                         {id === '3' && <img src={maakResidence2} alt="" />}
//                                     </div>
//                                     <div>
//                                         {id === '1' && <img src={aizelInterior1} alt="" />}
//                                         {id === '2' && <img src={maakResidence1} alt="" />}
//                                         {id === '3' && <img src={whatsappImg} alt="" />}
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="tag-share clearfix">
//                                 <div className="tag">
//                                     <span>Share: </span>
//                                     <ul>
//                                         <li><Link to="/blog-single/1">Planning</Link></li>
//                                         <li><Link to="/blog-single/1">Architecture</Link></li>
//                                         <li><Link to="/blog-single/1"> creative</Link></li>
//                                     </ul>
//                                 </div>
//                             </div>
//                             <div className="tag-share-s2 clearfix">
//                                 <div className="tag">
//                                     <span>Share: </span>
//                                     <ul>
//                                         <li><Link to="/blog-single/1">facebook</Link></li>
//                                         <li><Link to="/blog-single/1">twitter</Link></li>
//                                         <li><Link to="/blog-single/1">linkedin</Link></li>
//                                         <li><Link to="/blog-single/1">pinterest</Link></li>
//                                     </ul>
//                                 </div>
//                             </div>

//                             {/* <div className="author-box">
//                                 <div className="author-avatar">
//                                     <Link to="/blog-single/1" target="_blank"><img src={blog6} alt="" /></Link>
//                                 </div>
//                                 <div className="author-content">
//                                     <Link to="/blog-single/1" className="author-name">Author: Jenny Watson</Link>
//                                     <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis.</p>
//                                     <div className="socials">
//                                         <ul className="social-link">
//                                             <li><Link to="/blog-single/1"><i className="ti-facebook"></i></Link></li>
//                                             <li><Link to="/blog-single/1"><i className="ti-twitter-alt"></i></Link></li>
//                                             <li><Link to="/blog-single/1"><i className="ti-linkedin"></i></Link></li>
//                                             <li><Link to="/blog-single/1"><i className="ti-instagram"></i></Link></li>
//                                         </ul>
//                                     </div>
//                                 </div>
//                             </div> */}

//                             {/* <div className="more-posts">
//                                 <div className="previous-post">
//                                     <Link to="/blog">
//                                         <span className="post-control-link">Previous Post</span>
//                                         <span className="post-name">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium.</span>
//                                     </Link>
//                                 </div>
//                                 <div className="next-post">
//                                     <Link to="/blog-left-sidebar">
//                                         <span className="post-control-link">Next Post</span>
//                                         <span className="post-name">Dignissimos ducimus qui blanditiis praesentiu deleniti atque corrupti quos dolores</span>
//                                     </Link>
//                                 </div>
//                             </div> */}

//                             {/* <div className="comments-area">
//                                 <div className="comments-section">
//                                     <h3 className="comments-title">Comments</h3>
//                                     <ol className="comments">
//                                         <li className="comment even thread-even depth-1" id="comment-1">
//                                             <div id="div-comment-1">
//                                                 <div className="comment-theme">
//                                                     <div className="comment-image"><img src={blog3} alt="" /></div>
//                                                 </div>
//                                                 <div className="comment-main-area">
//                                                     <div className="comment-wrapper">
//                                                         <div className="comments-meta">
//                                                             <h4>John Abraham <span className="comments-date">January 12,2021
//                                                                 At 9.00am</span></h4>
//                                                         </div>
//                                                         <div className="comment-area">
//                                                             <p>I will give you a complete account of the system, and
//                                                                 expound the actual teachings of the great explorer of
//                                                                 the truth, </p>
//                                                             <div className="comments-reply">
//                                                                 <Link className="comment-reply-link" to="/blog-single/1"><span>Reply</span></Link>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <ul className="children">
//                                                 <li className="comment">
//                                                     <div>
//                                                         <div className="comment-theme">
//                                                             <div className="comment-image"><img src={blog4} alt="" /></div>
//                                                         </div>
//                                                         <div className="comment-main-area">
//                                                             <div className="comment-wrapper">
//                                                                 <div className="comments-meta">
//                                                                     <h4>Lily Watson <span className="comments-date">January
//                                                                         12,2021 At 9.00am</span></h4>
//                                                                 </div>
//                                                                 <div className="comment-area">
//                                                                     <p>I will give you a complete account of the system,
//                                                                         and expound the actual teachings of the great
//                                                                         explorer of the truth, </p>
//                                                                     <div className="comments-reply">
//                                                                         <Link className="comment-reply-link" to="/blog-single/1"><span>Reply</span></Link>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <ul>
//                                                         <li className="comment">
//                                                             <div>
//                                                                 <div className="comment-theme">
//                                                                     <div className="comment-image"><img src={blog5} alt="" /></div>
//                                                                 </div>
//                                                                 <div className="comment-main-area">
//                                                                     <div className="comment-wrapper">
//                                                                         <div className="comments-meta">
//                                                                             <h4>John Abraham <span className="comments-date">January
//                                                                                 12,2021 At 9.00am</span></h4>
//                                                                         </div>
//                                                                         <div className="comment-area">
//                                                                             <p>I will give you a complete account of the
//                                                                                 system, and expound the actual teachings
//                                                                                 of the great explorer of the truth, </p>
//                                                                             <div className="comments-reply">
//                                                                                 <Link className="comment-reply-link" to="/blog-single/1"><span>Reply</span></Link>
//                                                                             </div>
//                                                                         </div>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </li>
//                                                     </ul>
//                                                 </li>
//                                             </ul>
//                                         </li>
//                                         <li className="comment">
//                                             <div>
//                                                 <div className="comment-theme">
//                                                     <div className="comment-image"><img src={blog3} alt="" /></div>
//                                                 </div>
//                                                 <div className="comment-main-area">
//                                                     <div className="comment-wrapper">
//                                                         <div className="comments-meta">
//                                                             <h4>John Abraham <span className="comments-date">January 12,2021
//                                                                 At 9.00am</span></h4>
//                                                         </div>
//                                                         <div className="comment-area">
//                                                             <p>I will give you a complete account of the system, and
//                                                                 expound the actual teachings of the great explorer of
//                                                                 the truth, </p>
//                                                             <div className="comments-reply">
//                                                                 <Link className="comment-reply-link" to="/blog-single/1"><span>Reply</span></Link>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </li>
//                                     </ol>
//                                 </div>
//                                 <div className="comment-respond">
//                                     <h3 className="comment-reply-title">Post Comments</h3>
//                                     <form onSubmit={submitHandler} id="commentform" className="comment-form">
//                                         <div className="form-textarea">
//                                             <textarea id="comment" placeholder="Write Your Comments..."></textarea>
//                                         </div>
//                                         <div className="form-inputs">
//                                             <input placeholder="Website" type="url" />
//                                             <input placeholder="Name" type="text" />
//                                             <input placeholder="Email" type="email" />
//                                         </div>
//                                         <div className="form-submit">
//                                             <input id="submit" value="Post Comment" type="submit" />
//                                         </div>
//                                     </form>
//                                 </div>
//                             </div> */}
//                         </div>
//                     </div>
//                     {/* <BlogSidebar blLeft={props.blLeft}/> */}
//                 </div>
//             </div>
//         </section>
//     )

// }

// export default BlogSingle;



























import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { getBlogById } from "../../api/BlogSingle"; // updated import
import "./style.css";

const BlogSingle = () => {
  const { id } = useParams(); // now using id
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      setLoading(true);
      const data = await getBlogById(id);
      setBlog(data);
      setLoading(false);
    };
    fetchBlog();
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (!blog) return <p>Blog not found.</p>;

  return (
    <section className="wpo-blog-single-section section-padding">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col col-lg-10 col-12">
            <div className="wpo-blog-content">
              <div className="post format-standard-image">
                <div className="entry-media">
                  <img src={blog.mainImage} alt={blog.blogTitle} />
                </div>

                <div className="entry-meta">
                  <ul>
                    <li>
                      <i className="fi flaticon-user"></i> By{" "}
                      <Link to={`/blog-single/${blog.id}`}>{blog.authorTitle}</Link>
                    </li>
                    <li>
                      <i className="fi flaticon-calendar"></i> {blog.created}
                    </li>
                  </ul>
                </div>

                <h2>{blog.blogTitle}</h2>
                <p>{blog.p1}</p>

                <blockquote>{blog.blogquote}</blockquote>

                <p>{blog.p2}</p>

                <div className="gallery">
                  <div>
                    <img src={blog.secondaryImage1} alt="Gallery 1" />
                  </div>
                  <div>
                    <img src={blog.secondaryImage2} alt="Gallery 2" />
                  </div>
                </div>
              </div>

              <div className="tag-share clearfix">
                <div className="tag">
                  <span>Share: </span>
                  <ul>
                    <li>
                      <Link to={`/blog-single/${blog.id}`}>Planning</Link>
                    </li>
                    <li>
                      <Link to={`/blog-single/${blog.id}`}>Architecture</Link>
                    </li>
                    <li>
                      <Link to={`/blog-single/${blog.id}`}>Creative</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="tag-share-s2 clearfix">
                <div className="tag">
                  <span>Share: </span>
                  <ul>
                    <li>
                      <Link to={`/blog-single/${blog.id}`}>Facebook</Link>
                    </li>
                    <li>
                      <Link to={`/blog-single/${blog.id}`}>Twitter</Link>
                    </li>
                    <li>
                      <Link to={`/blog-single/${blog.id}`}>LinkedIn</Link>
                    </li>
                    <li>
                      <Link to={`/blog-single/${blog.id}`}>Pinterest</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSingle;
